import React from 'react'
import { View, StyleSheet } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Text } from '@components'
import { Theme } from '@theme'

interface StepTitleProps {
  mainTitle: string
  subtitle: string
}

export const StepTitle: React.FC<StepTitleProps> = ({ mainTitle, subtitle }) => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <View style={styles.titleContainer}>
      <Text style={styles.mainTitle} type="title" color={theme.colors.primary}>
        {mainTitle}
      </Text>
      <Text style={styles.subtitle} type="bodySmall" color={theme.colors.lightGrey}>
        {subtitle}
      </Text>
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    titleContainer: {
      alignItems: 'flex-start',
      paddingTop: theme.spacing.xl,
      paddingBottom: theme.spacing.lg,
    },
    mainTitle: {
      textAlign: 'left',
      paddingBottom: theme.spacing.sm,
      color: theme.colors.black,
    },
    subtitle: {
      textAlign: 'left',
    },
  }) 